import { ProviderPlugin } from './thirdPartyLoader';
import loadScript from '../loadScript';

function gtagProvider(): ProviderPlugin {
  return {
    initialize: () => {
      if (!window.GOOGLE_ANALYTICS_ENABLED) {
        return;
      }
      loadScript({
        src: 'https://www.googletagmanager.com/gtag/js?id=UA-60829200-1',
        async: true,
      });

      window.dataLayer = window.dataLayer || [];

      window.gtag = function() {
        window.dataLayer.push(arguments);
      };
      window.gtag('js', new Date());

      // window.gtag('config', 'UA-60829200-1');
      window.gtag('config', 'AW-769894422');
    },
    loaded: () => {
      return !!window.gtag && !!window.dataLayer;
    },
  };
}

export default gtagProvider;
